import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./styles.less";
import ThumbNailImage from "../ThumbNailImage";
import ThumbNailText from "../ThumbNailText";

/// Thumbnail has 2 types of views:
/// The carousel room type ( has it is in the room results view )
/// The hotel/room type inside GroupResult ( has it is in the region results view and any mobile view )
/// *** CURRENTLY UNAVAILABLE OPTION *** extendedType prop: 'true' - for hotel type ( hotel type  is more exetended ) , otherwise - room type.

const imageSrcWithCrop = src => `${src}?w=450&h=300&mode=crop`;
const noop = () => {};

class ThumbNail extends React.Component {
  state = { shouldFetchDefaultImage: true, finishedRendering: false };

  componentDidMount() {
    // setInterval(() => {
    this.setState({ finishedRendering: true });
    // }, 0);
  }

  onClick = () => {
    const { onClick, product } = this.props;

    onClick(product.id, product.hotelId);
  };

  onWrapperClick = () => {
    // const { isMobileView } = this.props;

    // if (isMobileView) {
    //   return;
    // }
    this.onClick();
  };

  onMoreDetailsClick = event => {
    const { product, onMoreDetailsClick } = this.props;
    onMoreDetailsClick(product);
    event.stopPropagation();
  };

  onImageError = e => {
    // if we already tried to fetch the default then we don't want to fetch it again
    // in cases where the default is also throwing an error (infinite fetching loop)
    const { shouldFetchDefaultImage } = this.state;
    if (!shouldFetchDefaultImage) {
      return;
    }

    // fetch the default on error, but set the flag so we don't fetch anymore
    this.setState({ shouldFetchDefaultImage: false });
    const defaultImage = this.getDefaultImage();
    e.target.src = imageSrcWithCrop(defaultImage);
  };

  getDefaultImage = () => {
    const { product } = this.props;
    return product.defaultImageUrl || product.defaultImage;
  };

  render() {
    const {
      clickable,
      active,
      isRtl,
      isMobileView,
      selectIndicator,
      titles,
      product,
      showClubPrices,
      extendedType,
      inCarousel,
      renderMarkup,
      renderImageMarkup,
      onImageLoad,
      isIos,
      showPricePerNightThumb
    } = this.props;
    const { shouldFetchDefaultImage } = this.state;
    const imageErrorHandler = shouldFetchDefaultImage
      ? this.onImageError
      : noop;
    const { finishedRendering } = this.state;

    return (
      <div
        onClick={this.onWrapperClick}
        onKeyDown={this.onWrapperClick}
        role="button"
        tabIndex="0"
        className={cx(styles.thumbnail, {
          [styles.clickable]: clickable,
          [styles.rtl]: isRtl,
          [styles.mobileView]: isMobileView,
          [styles.carouselView]: inCarousel,
          [styles.appeared]: finishedRendering
        })}
        id={product.id}
      >
        <div
          className={cx(styles.container, {
            [styles.active]: active
          })}
        >
          <ThumbNailImage
            titles={titles}
            product={product}
            onImageLoad={onImageLoad}
            renderImageMarkup={renderImageMarkup}
            isIos={isIos}
            onError={imageErrorHandler}
            getDefaultImage={this.getDefaultImage}
          />
          <ThumbNailText
            isRtl={isRtl}
            titles={titles}
            product={product}
            onClick={this.onClick}
            showClubPrices={showClubPrices}
            extendedType={extendedType}
            isMobileView={isMobileView}
            onMoreDetailsClick={this.onMoreDetailsClick}
            renderMarkup={renderMarkup}
            showPricePerNightThumb={showPricePerNightThumb}
          />
        </div>
        <div
          className={cx(styles.selectIndicator, styles[selectIndicator], {
            [styles.open]: active
          })}
        />
      </div>
    );
  }
}

ThumbNail.defaultProps = {
  selectIndicator: "arrowDown",
  isMobileView: false,
  inCarousel: false
};

ThumbNail.propTypes = {
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  selectIndicator: PropTypes.oneOf(["stripe", "arrowDown"]),
  product: PropTypes.object,
  clickable: PropTypes.bool,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  showClubPrices: PropTypes.bool,
  extendedType: PropTypes.bool,
  inCarousel: PropTypes.bool,
  isMobileView: PropTypes.bool,
  onMoreDetailsClick: PropTypes.func,
  renderMarkup: PropTypes.func,
  onImageLoad: PropTypes.func,
  renderImageMarkup: PropTypes.func,
  isIos: PropTypes.bool,
  showPricePerNightThumb: PropTypes.bool
};

export default ThumbNail;



// WEBPACK FOOTER //
// ./src/components/ThumbNail/ThumbNail.js